import { Grid, TextField } from '@mui/material'
import { formatUsPhone } from '../../../lib/phone'
import type { RecruiterProfileFormApi } from '../../../hooks/useRecruiterProfileForm'

/** Recruiter contact info + position, shared by the onboarding wizard and the edit form. */
export const ContactInfoFields = ({ form }: { form: RecruiterProfileFormApi }) => {
  const { data, fieldErrors, setData, validateField } = form

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="First Name"
          value={data.personalInfo.firstName}
          error={!!fieldErrors['contactInfo.firstName']}
          helperText={fieldErrors['contactInfo.firstName']}
          onChange={e => {
            const next = {
              ...data,
              personalInfo: { ...data.personalInfo, firstName: e.target.value },
            }
            setData(next)
            validateField('contactInfo', next)
          }}
          onBlur={() => validateField('contactInfo', data)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Last Name"
          value={data.personalInfo.lastName}
          error={!!fieldErrors['contactInfo.lastName']}
          helperText={fieldErrors['contactInfo.lastName']}
          onChange={e => {
            const next = {
              ...data,
              personalInfo: { ...data.personalInfo, lastName: e.target.value },
            }
            setData(next)
            validateField('contactInfo', next)
          }}
          onBlur={() => validateField('contactInfo', data)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Email Address"
          type="email"
          value={data.personalInfo.email}
          error={!!fieldErrors['contactInfo.email']}
          helperText={fieldErrors['contactInfo.email']}
          onChange={e => {
            const next = { ...data, personalInfo: { ...data.personalInfo, email: e.target.value } }
            setData(next)
            validateField('contactInfo', next)
          }}
          onBlur={() => validateField('contactInfo', data)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Phone Number"
          value={data.personalInfo.phone}
          error={!!fieldErrors['contactInfo.phone']}
          helperText={fieldErrors['contactInfo.phone']}
          onChange={e => {
            const next = {
              ...data,
              personalInfo: { ...data.personalInfo, phone: formatUsPhone(e.target.value) },
            }
            setData(next)
            validateField('contactInfo', next)
          }}
          onBlur={() => validateField('contactInfo', data)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          required
          label="Position"
          value={data.personalInfo.position}
          error={!!fieldErrors.position}
          helperText={fieldErrors.position}
          onChange={e => {
            const next = {
              ...data,
              personalInfo: { ...data.personalInfo, position: e.target.value },
            }
            setData(next)
            validateField('position', next)
          }}
          onBlur={() => validateField('position', data)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Bio (Optional)"
          value={data.personalInfo.bio}
          onChange={e =>
            setData({ ...data, personalInfo: { ...data.personalInfo, bio: e.target.value } })
          }
        />
      </Grid>
    </Grid>
  )
}
